// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrapper[data-v-7bfd58cb]{align-items:center;background-image:linear-gradient(147deg,#001b52,#000e29 100%);bottom:0;display:flex;flex-direction:column;left:0;overflow:auto;position:fixed;right:0;top:0}footer[data-v-7bfd58cb]{color:rgba(var(--primary-color),.32);font-size:1rem;font-weight:600;line-height:1.5rem;padding:1rem 0;position:relative;text-align:center}footer a[data-v-7bfd58cb]{-webkit-text-decoration:underline;text-decoration:underline}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
